<template>
  <div class="guide">
    <!-- top switch -->
    <div class="top" 
         v-show="currentShow == 1 || currentShow == 2"
         :style="{
          paddingTop: `${15 + statusBarHeight}px`
         }">
        <!-- backIcon -->
        <Back 
          :clickHandle="handleClosePage"
          :innerText="localesPackage?.['yuli_back']?.[localesEnv]"
        />
        <!-- switch -->
        <div class="top-switch">
            <div class="top-switch-item"
                @click="switchHandle(1)"
                :class="[{'active': currentShow == 1}]">
                <div class="top-switch-normalText"
                    :class="[{'active-text': currentShow == 1}]"
                >
                  {{ localesPackage?.['h5_guide_gift']?.[localesEnv] }}
                </div>
            </div>
            <!-- <div v-show="currentShow == 1" class="top-switch-active-left"></div> -->
            <div class="top-switch-item"
                @click="switchHandle(2)"
                :class="[{'active': currentShow == 2}]">
                <div class="top-switch-normalText"
                    :class="[{'active-text': currentShow == 2}]"
                >
                {{ localesPackage?.['h5_guide_skill']?.[localesEnv] }}
                </div>
            </div>
        </div>
        <!-- page -->
        <div class="top-content">
            <Gift :roleId="roleTypeValue" :giftData="getGiftData" v-show="currentShow == 1"/>
            <Skill :roleId="roleTypeValue" :skillData="getSkillData" v-show="currentShow == 2"/>
        </div>
    </div>
  </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, getCurrentInstance } from "vue";
import { useRoute } from 'vue-router';
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import Gift from "./components/Gift";
import Skill from "./components/Skill";
import Back from "@/components/universal/Back";
import { getAllRole } from "@/api/guideRole.js";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import {getGuideRoleLanguage} from "@/api/language.js";
import store from "@/store";

export default {
  components: {
    Gift,
    Skill,
    Back
  },
  props: {
    id: {
        type: Number,
        default: 0,
    },
  },
  watch: {
    id: {
      async handler(value) {
        this.proxy.$loading.show();
        if(!value)return;
        this.roleTypeValue = value;
      },
      immediate: true,
      deep: true,
    },
    init: {
      async handler() {
        const timer = setInterval(()=>{
          if(!this.roleTypeValue)return;
          clearInterval(timer);
          this.fristInit();
        }, 333)
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        console.log('languageEnv: ', value);
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        console.log('languagePackage: ', value);
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const {id} = props;
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const route = useRoute();
    const currentShow = ref(3);
    const currentId = ref(id);
    const currentRoleData = ref([]);
    const roleTypeValue = ref(null);
    const getGiftData = ref([]);
    const getSkillData = ref([]);

    onBeforeMount(async ()=>{
      appBridging.getSettingLaungage();
      const res = await getGuideRoleLanguage();
      store.dispatch("global/setLanguagePackage", res);// 存到stroe
    })

    onMounted(() => {
      appBridging.getStatusBarHeight();
    });
    /**
     * 关闭页面
     */
    const handleClosePage = () => {
        appBridging.closePage();
    };
    /**switch */
    const switchHandle = (key) => {
        currentShow.value = key;
    };

    const fristInit = async () => {
      let data = [];
      try {
        const res = await getAllRole();
        data = res.data;
      } catch (error) {
        proxy.$toast.show({
          msg: "Network Error",
          type: TOAST_TYPE.ERROR,
        })
        console.log(error);
      }
      console.log(data);
      currentRoleData.value = data;
      data?.forEach(item => {
        const { gifts, name, role_type, skills } = item;
        if(roleTypeValue.value == role_type){
          // 配置天赋列表
          getGiftData.value = gifts?.map(item => {
            const {description, detail, icon_url, name} = item;
            return {
              labelName: name,
              labelUrl: icon_url,
              content: detail
            }
          }) || [];
          // 配置技能列表
          getSkillData.value = skills?.map(item => {
            const {description, detail, icon_url, name} = item;
            return {
              labelName: name,
              labelUrl: icon_url,
              content: detail
            }
          }) || [];
        }
      })
      // 等待数据到才显示页面
      if(route.query?.tab == 'skill'){
        currentShow.value = 2;
      }else {
        currentShow.value = 1;
      }
      // 等待背景图加载完成后 - 关闭原生loading
      const backgroundImgUrl = require('@/assets/images/YuliApp/guiderole/guide_bg.png');
      const backgroundImg = new Image();
      backgroundImg.onload = function(){
        appBridging.closeLoading();
        proxy.$loading.hide();
      }
      backgroundImg.src = backgroundImgUrl;
    }

    return {
      fristInit,
      handleClosePage,
      switchHandle,
      currentShow,
      currentId,
      currentRoleData,
      getGiftData,
      getSkillData,
      route,
      localesPackage,
      localesEnv,
      roleTypeValue,
      proxy
    };
  },
};
</script>

<style lang="less" scoped>
    @topHight: 70px;

    .guide {
        height: 100vh;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        background: url("~@/assets/images/YuliApp/guiderole/guide_bg.png") no-repeat top left;
        background-size: 100% 100%;
    }
    .top{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: @topHight;

        &-switch{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            
            position: absolute;
            left: 50%;
            bottom: -25px;
            transform: translate(-50%, 50%);
            z-index: 1;
            
            // border: 1px solid #242424;
            // border-radius: 20px;
            // background-color: #7774A1;

            &-item{
                line-height: 34px;
                // width: 50%;
                // height: 100%;
                width: 155px;
                height: 31px;
                background: url("~@/assets/images/YuliApp/guiderole/normal_switch.png") no-repeat top left;
                background-size: 100% 100%;
                // margin: 0 10px;
                position: relative;
            }
            &-normalText{
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%,-50%);
              z-index: 1;
              color: #ffffff;
              font-size: 16px;
              font-weight: 500;
              font-family: "PingFang SC";
              text-align: center;
            }
            .active{
                
                // width: 105px;
                // height: 31px;
                background: url("~@/assets/images/YuliApp/guiderole/active_switch.png") no-repeat top left;
                background-size: 100% 100%;
                // border-radius: 20px;
                // border: 1px solid #242424ff;
                // background: #f6fafdff;
            }
            .active-text{
              color: #000;
            }
        }

        &-content{
            margin-top: calc(@topHight + 65px);
            overflow-y: scroll;
            height: calc(100vh - @topHight);
        }
    }
</style>